import {Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import {forwardRef, useImperativeHandle, useState} from "react";
import myFittingExpLogo from "../../assets/images/myfittingexp.png";
import {useRecommendHeaderAdminPortal} from "../../hooks/useRecommendHeaderAdminPortal";
import FittingRecommendHeader from "./FittingRecommendHeader";
import FittingsDetailHeader from "./FittingsDetailHeader";
import FittingsOrders from "./FittingsOrders";
import {useFittingOrdersAdminPortal} from "../../hooks/useFittingOrdersAdminPortal";
const FittingDialog = forwardRef(({data}, ref) => {
    const [open, setOpen] = useState(false);
    useImperativeHandle(ref, () => ({
        handleOpen: () => setOpen(true),
        handleClose: () => setOpen(false),
    }));
    const {data: recommendHeader, isLoading, error} = useRecommendHeaderAdminPortal(data?.id);
    const {data: orders, isLoading: isLoadingOrder, error: errorOrder} = useFittingOrdersAdminPortal(data?.id);
    if (!data) return null;

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
            <DialogTitle sx={{textAlign: "center"}}>
                <Box component="img" src={myFittingExpLogo} alt="MFE Logo" sx={{width: 240}} />
                <Typography sx={{fontSize: 24, fontWeight: "bold"}}>FITTING DETAIL</Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <FittingsDetailHeader data={data} />
                    <FittingRecommendHeader recommendHeader={recommendHeader} isLoading={isLoading} />
                    <FittingsOrders orders={orders} />
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpen(false)} variant="contained" color="primary">
                    Close
                </Button>
            </DialogActions>
            {error && (
                <Alert severity="error" sx={{mb: 2}}>
                    {error?.response?.data?.message || error.message || "Failed to load recommended header."}
                </Alert>
            )}
            {errorOrder && (
                <Alert severity="error" sx={{mb: 2}}>
                    {errorOrder?.response?.data?.message || errorOrder.message || "Failed to load recommended header."}
                </Alert>
            )}
        </Dialog>
    );
});

export default FittingDialog;
